export default __webpack_public_path__ + "static/media/icn-delete-24px.c8c04ac7.svg";